export enum HubloPoolDocumentTag {
  POOL_PROFILE_DOCUMENT_NEEDS_REVIEW = 'POOL_PROFILE_DOCUMENT_NEEDS_REVIEW',
}
